<template><div><h1 id="buchungen-einlesen" tabindex="-1"><a class="header-anchor" href="#buchungen-einlesen"><span>Buchungen einlesen</span></a></h1>
<p>Buchungen einlesen — Einlesen von Gutschriften, Erfassung und Protokoll</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Maske werden die Einlesejobs für Gutschriften (ESR, LSV, Debit Direct und den Statusreport) erfasst. Der Statusrepoprt nuss nach der Aufgabe von CH-DD-Lastschriften eingelsesn werden, damit nicht ausgeführte Transaktionen bearbeitet und protokolliert werden können.</p>
<p>Automatisch erkannt werden folgende Formate:</p>
<ul>
<li>
<p>camt.053, mit Details (Gutschriften)</p>
</li>
<li>
<p>camt.054 (Gutschriften)</p>
</li>
<li>
<p>ESR-Typ 3 (Gutschriften aus LSV, bis 2018)</p>
</li>
<li>
<p>pain.002 (Statusreport)</p>
</li>
</ul>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Buchungen einlesen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-Datum (Job-Datum/Nr.)</dt>
<dd>Datum zur Identifikation des Jobs (frei wählbar, sowie eine aufsteigende Nummer, welche durch das System automatisch vergeben wird</dd>
<dt>Verarbeitungsdatum</dt>
<dd>Verarbeitungsdatum des Jobs.</dd>
<dt>Dateityp</dt>
<dd>Format der eingelesenen Datei (&quot;camt.053&quot;, &quot;camt.054&quot;, &quot;ESR-Typ 3&quot; oder &quot;pain.002&quot;).</dd>
<dt>Quelldatei</dt>
<dd>Kompletter Pfadname der Quelldatei. Die Dateien werden vom System verwaltet, so dass es nicht möglich ist, zweimal die gleichen Daten zu verarbeiten. Zusätzlich wird das Zahlungsfile auch auf formale Richtigkeit geprüft. Nach Eingabe des Dateinamens erscheinen die statistischen Angaben (Anzahl erwartet, etc.) im Fenster. Findet das System keine Datei mit diesem Namen, wird eine Fehlermeldung ausgegeben.</dd>
<dt>Erstelldatum Quelldatei</dt>
<dd>Produktionsdatum der Quelldatei (ausgelesen aus Quelldatei).</dd>
<dt>Transaktionen</dt>
<dd>hier wird eine Ausertung über die in der Quelldatei enthaltenen Datensätze angezeigt.</dd>
<dt>Erwartet</dt>
<dd>Anzahl Datensätze in der Quelldatei.</dd>
<dt>Gutschriften</dt>
<dd>Anzahl Gutschriften in der Quelldatei.</dd>
<dt>Korrekturen</dt>
<dd>Anzahl Korrekturen in der Quelldatei.</dd>
<dt>Storni</dt>
<dd>Anzahl Storni in der Quelldatei. Darin sind Widerrufe und Rückbuchungen (nur DD) enthalten. Eine Detailübersicht der Storni wird im Frame &quot;Storni Detail&quot; angezeigt.</dd>
<dt>Fehlerhaft</dt>
<dd>Datensätze, die nicht gelesen oder zugeordnet werden können.</dd>
<dt>Eingelesen</dt>
<dd>Anzahl der aus der Quelldatei. eingelesenen Datensätze. Muss bei korrekter Verarbeitung mit &quot;Anzahl Erwartet&quot; übereinstimmen.</dd>
<dt>Drucker</dt>
<dd>Name des Druckers, auf den der Protokoll-Ausdruck erfolgen soll.</dd>
<dt>Ausgabedatei</dt>
<dd>Pfad und Name der Protokolldatei. Wird nichts eingegeben, wird vom System der Standard-Name &quot;home/&lt;Erfasser&gt;/outprint.&lt;Erfasser&gt;&quot; übernommen.</dd>
<dt>Status</dt>
<dd>Verarbeitungsstatus des Jobs.</dd>
<dt>Gebühren (separater Frame)</dt>
<dd>Anzahl und Betrag pro Kontonummer (Spenden oder Kauf), nur Anzeige.</dd>
<dt>Storni Detail (separater Frame)</dt>
<dd>Detaillierte Auflistung der in der Quelldatei vorhandenen Storno-Transaktionen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="buchungen-einlesen-1" tabindex="-1"><a class="header-anchor" href="#buchungen-einlesen-1"><span>Buchungen einlesen</span></a></h3>
<p>Dieser Job liest die Daten ein und verbucht die Zahlungen bei den Adressen. Nach der fehlerlosen Durchführung wird im Protokollfenster hinter der Jobnummer &quot;Job erledigt; Protokoll gedruckt&quot; angezeigt.</p>
<p>Details siehe <RouteLink to="/referenz/refs/ft.refproc.bucheinl.html" title="Buchungen einlesen">Buchungen einlesen</RouteLink>.</p>
<h3 id="test-daten-einlesen" tabindex="-1"><a class="header-anchor" href="#test-daten-einlesen"><span>Test Daten einlesen</span></a></h3>
<p>Hier besteht die Möglichkeit, Zahlungsfiles nur testmässig einzulesen. Mit dieser Funktion werden keine Buchungen vorgenommen. Die Parametrisierung ist wie beim Job <RouteLink to="/referenz/refs/ft.refproc.bucheinl.html" title="Buchungen einlesen">Buchungen einlesen</RouteLink>.</p>
<h3 id="buchungen-stornieren" tabindex="-1"><a class="header-anchor" href="#buchungen-stornieren"><span>Buchungen stornieren</span></a></h3>
<p>Bei irrtümlich falsch eingelesenen und verarbeiteten Zahlungsfiles besteht hier die Möglichkeit, alles wieder rückgängig zu machen; d.h. stornieren der Einzelbuchungen. Die Parametrisierung ist wie beim Job <RouteLink to="/referenz/refs/ft.refproc.bucheinl.html" title="Buchungen einlesen">Buchungen einlesen</RouteLink>.</p>
<h3 id="fehlerliste-esr-zahlungen-drucken" tabindex="-1"><a class="header-anchor" href="#fehlerliste-esr-zahlungen-drucken"><span>Fehlerliste ESR-Zahlungen drucken...</span></a></h3>
<p>Druckt das Protokoll, mit Status der Bearbeitung aus der <RouteLink to="/manual/buchhaltung/debitorenverwaltung.html#ESR-Fehlerliste" title="1.4.1. bearbeitung von nicht importierten Buchungen (ESR Fehlerliste)">ESR-Fehlerliste</RouteLink>.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.bucheinl.html" title="Buchungen einlesen">Buchungen einlesen (Job)</RouteLink>, <RouteLink to="/manual/buchhaltung/debitorenverwaltung.html#ESR-Fehlerliste" title="1.4.1. bearbeitung von nicht importierten Buchungen (ESR Fehlerliste)">ESR-Fehlerliste</RouteLink></p>
</div></template>


